import {useCallback} from 'react';

import {UserType} from '../../service/user/user-type';
import {useLocale} from '../locale/locale-hook';

enum UsertourRoleEnum {
    Test = 'Test',
    DoubleGis = '2gis',
    RD = 'RD',
    Staff = 'Staff',
}

type UsertourHookType = {
    identify: (user: UserType) => void;
};

function getRole(user: UserType): UsertourRoleEnum {
    if (user.isStaff) {
        return UsertourRoleEnum.Staff;
    }

    if (user.isTestUser) {
        return UsertourRoleEnum.Test;
    }

    if (user.isDoubleGisUser) {
        return UsertourRoleEnum.DoubleGis;
    }

    return UsertourRoleEnum.RD;
}

export function useUsertour(): UsertourHookType {
    const {shortLocaleName} = useLocale();

    const identify = useCallback(
        (user: UserType) => {
            window.usertour?.identify(String(user.id), {
                Lang: shortLocaleName.toUpperCase(),
                Role: getRole(user),
            });
        },
        [shortLocaleName]
    );

    return {identify};
}
